import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

export const CountUp = ({ value, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const match = String(value).match(/^([^\d]*)([\d.,]+)(.*)$/);
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!inView || !match) return;
    const target = parseFloat(match[2].replace(/,/g, ""));
    const decimals = (match[2].split(".")[1] || "").length;
    const controls = animate(0, target, {
      duration: 2.2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) =>
        setDisplay(
          `${match[1]}${decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString("en-US")}${match[3]}`
        ),
    });
    return () => controls.stop();
  }, [inView]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
};
